import React from 'react'

import Illustration from '../../components/helpers/Illustration'
import * as S from './styled'

const BrandVistor = () => (
  <S.BrandVistorWrapper>
    <Illustration name="brand-owli" />
  </S.BrandVistorWrapper>
)

export default BrandVistor
